import axios from "axios";

const getAllSermons = () => {
    return axios.get("/site/server/get_sermon_list.php");
};

export default getAllSermons;